module.exports = "Page Not Found"


//////////////////
// WEBPACK FOOTER
// D:/a/29/s/PDMI.PharmacyLocator.Web/src/app/page-not-found/page-not-found.component.html
// module id = ../../../../../src/app/page-not-found/page-not-found.component.html
// module chunks = main